module.exports = __webpack_public_path__ + "static/media/pdf.ae0f7e04.svg";